<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ dialogData?.title | translate }}
  </h1>
  <div mat-dialog-content>
    <div class="description">
      <p>
        {{ dialogData?.mainText | translate }}
        @if (dialogData?.highlightedText) {
        <span class="highlight-text">{{ dialogData?.highlightedText }} </span>
        ? }
      </p>
      @if (dialogData?.additionalTextBlock) {
      <p [innerHTML]="dialogData?.additionalTextBlock"></p>
      }
    </div>
  </div>
  @if (!dialogData?.hideActions) {
  <div mat-dialog-actions class="tw-flex tw-flex-col">
    @if (dialogData?.showComment) {
    <label class="tw-text-left tw-mb-1 tw-w-full">{{
      'monitoring.allocationView.confirmation.comment' | translate
    }}</label>
    <textarea
      class="tw-w-full tw-box-border tw-resize-none"
      style="min-height: 100px"
      maxlength="300"
      (input)="onCommentInput($event)"
    ></textarea>
    <span class="tw-text-xs tw-self-end tw-mb-4">{{ commentLength }}/{{ commentMaxLength }}</span>
    }
    <div
      [class]="dialogData?.hideCancel ? 'tw-flex tw-justify-center tw-w-full' : 'tw-flex tw-justify-between tw-w-full'"
    >
      @if (!dialogData?.hideCancel) {
      <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
      }
      <ui-action-button
        [action]="dialogData?.buttonAction"
        [type]="!!dialogData ? dialogData.buttonType : buttonType.Secondary"
        (buttonClick)="confirm()"
      ></ui-action-button>
    </div>
  </div>
  }
</div>
